import handlebars from "handlebars";
import { AppraisalAttachment, GetAppraisalModel } from "../../../../../all_Interfaces";
import documentTemplate from "../templates/documentTemplate";

export const compileDocumentTemplate = (
    documents:AppraisalAttachment[]
  ): string => {
    const compiledDocumentTemplate = handlebars.compile(documentTemplate);
    const dayjs = require('dayjs');
// lastModifiedDate

    var formattedDoc:AppraisalAttachment[] = [];
    if(documents.length != 0){
        documents.forEach((data:AppraisalAttachment) => {
            const doc = {...data,lastModifiedDate:dayjs(data.lastModifiedDate, "M/D/YYYY, h:mm:ss A").format("MMM-DD-YYYY HH:mm:ss")};
            formattedDoc.push(doc);
        })
    }
    const data = {
        doc: [...formattedDoc],
        empty: formattedDoc.length == 0 ? 'true' : 'false',
    }

    console.log(data);

    return compiledDocumentTemplate(data);
}